import { useState } from 'react';

// components
import {
  IEditForm,
  CasEditForm,
  CasRHFTextField,
  CasRHFPercentField,
  CasRHFSwitch,
} from 'src/compass/shared/components';
import {
  CasAsOfContainer,
  CasAsOfMultiRowWithErrorDisplay,
  EntityInfoLRPAgencies,
  useDefaultAsOfValues,
} from 'src/compass/application/commissions';
import { CasRHFRiskManagerSelect, CasRHFSharepointSiteSelect } from 'src/compass/application';

// schema
import { LRPAgenciesSchema } from './LRPAgenciesSchema';

// ----------------------------------------------------------------------

export default function LRPAgenciesForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const [asofReadonly, setAsofReadonly] = useState(false);

  const defaultValues = useDefaultAsOfValues(row, { isActive: true });

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity={EntityInfoLRPAgencies.entity}
      schema={LRPAgenciesSchema}
    >
      <CasRHFTextField name="name" label="Name" />
      <CasRHFTextField name="agencyNbr" label="Agency#" />
      <CasRHFSharepointSiteSelect name="claimsSharepointSiteId" label="Sharepoint Site" />
      <CasRHFTextField name="claimsSharepointRoot" label="Sharepoint Root" />
      <CasRHFSwitch name="isActive" label="Active" />
      <CasAsOfContainer
        entityTitle='Agency AsOf'
        entityId={id}
        deleteChildEntity="Ins/Agency/AsOf"
        initialAsOfList={row?.asOfs}
        initialAsOf={defaultValues.asOf}
        readOnly={asofReadonly}
        setReadOnly={setAsofReadonly}
      >
        <CasAsOfMultiRowWithErrorDisplay
          title="Payouts"
          readOnly={asofReadonly}
          name="asOf.asOfTrails"
          triggerValidationList={['asOf.asOfTrails']}
          rowCountMode={0}
          columns={[
            {
              type: 'component',
              label: 'Employee',
              name: 'agentId',
              fullWidth: true,
              component: CasRHFRiskManagerSelect,
            },
            {
              type: 'component',
              label: 'Percent',
              name: 'percent',
              component: CasRHFPercentField,
            },
          ]}
        />
      </CasAsOfContainer>
    </CasEditForm>
  );
}
